import { PopoverContentV2Component, popoverContentV2Template } from './PopoverContentV2';
import styles from './PopoverContentV2.styles.scss';
export const popoverContentDefinition = {
    baseName: 'popover-content-v2',
    template: popoverContentV2Template,
    styles,
};
export const chameleonPopoverContentV2 = PopoverContentV2Component.compose(popoverContentDefinition);
